import { render, staticRenderFns } from "./ReportFlag.vue?vue&type=template&id=86a70866&"
import script from "./ReportFlag.vue?vue&type=script&lang=js&"
export * from "./ReportFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports